"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoiseDelay = void 0;
const ValueWithRandom_1 = require("../../../ValueWithRandom");
class NoiseDelay extends ValueWithRandom_1.ValueWithRandom {
    constructor() {
        super();
    }
}
exports.NoiseDelay = NoiseDelay;
